module.exports = __webpack_public_path__ + "img/bg-work.16266ce6.png";